import React, { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function DateRangeFilter({ timeFilter, setTimeFilter, dateFrom, setDateFrom, dateTo, setDateTo, onApplyRange }) {
  const [showRange, setShowRange] = useState(false);

  const handleQuickFilter = (value) => {
    setTimeFilter(value);
    setDateFrom('');
    setDateTo('');
    setShowRange(false);
  };

  const handleApplyRange = () => {
    if (dateFrom) {
      setTimeFilter('custom');
      if (onApplyRange) onApplyRange();
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <select
        data-testid="time-filter-select"
        value={showRange ? 'custom' : timeFilter}
        onChange={(e) => {
          if (e.target.value === 'custom') {
            setShowRange(true);
          } else {
            handleQuickFilter(e.target.value);
          }
        }}
        className="h-10 rounded border border-blue-200 bg-white px-3 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-600"
      >
        <option value="all">All Time</option>
        <option value="day">Today</option>
        <option value="week">This Week</option>
        <option value="month">This Month</option>
        <option value="year">This Year</option>
        <option value="custom">Custom Range</option>
      </select>

      {(showRange || timeFilter === 'custom') && (
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1">
            <CalendarDays size={14} className="text-blue-600" />
            <Input
              data-testid="date-from-input"
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className="h-10 w-36 rounded border-blue-200 text-sm"
              placeholder="From"
            />
          </div>
          <span className="text-xs text-slate-400">to</span>
          <Input
            data-testid="date-to-input"
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className="h-10 w-36 rounded border-blue-200 text-sm"
            placeholder="To"
          />
          <Button
            data-testid="apply-date-range"
            size="sm"
            onClick={handleApplyRange}
            disabled={!dateFrom}
            className="bg-blue-600 hover:bg-blue-700 text-white rounded text-xs font-bold"
          >
            Apply
          </Button>
        </div>
      )}
    </div>
  );
}
